import * as SentryD from "@sentry/browser";

export const Sentry = SentryD;

Sentry.init({
    dsn: "https://57571e2fb2d1848f04eb1f26c912531e@o4508888104632320.ingest.de.sentry.io/4508888107647056",
    integrations: [],
});

